import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {MatDialogRef} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {OfwcaService} from "../../../shared/services/ofwca.service";
import {HttpErrorResponse} from "@angular/common/http";
import {delay, takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-ofwca-rejected-commission-add',
  templateUrl: './ofwca-rejected-commission-add.component.html',
  styleUrls: ['./ofwca-rejected-commission-add.component.scss']
})
export class OfwcaRejectedCommissionAddComponent implements OnInit, OnDestroy  {

  ofwcaControl: FormControl;
  enableSaveButton = false;
  processingRequest = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    public dialogRef: MatDialogRef<OfwcaRejectedCommissionAddComponent>,
    private snack: MatSnackBar,
    private ofwcaService: OfwcaService,
    private fb: FormBuilder,
  ) {
    this.ofwcaControl = fb.control('', [Validators.required ]);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngOnInit(): void {
    this.ofwcaControl.valueChanges
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => this.enableSaveButton = this.ofwcaControl.valid);
  }

  sendForm(): void {
    this.processingRequest = true;

    this.ofwcaService.ofwcaRejectedCommission(this.ofwcaControl.value, 1)
      .subscribe(() => {
        this.snack.open('Pomyślnie dodano_OFWCA', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas dodawania wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });


      })
    ;
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }

}
